import { createReducer, on } from '@ngrx/store';
import { SecurityInfoApiActions } from './security-info.actions';
import { adapter, initialState } from './security-info.state';

export const MdmSecurityInfoFeatureKey = 'securityInfo';

export const SecurityInfoReducer = createReducer(
  initialState,
  on(SecurityInfoApiActions.securityInfoLoaded, (state, { securityInfo }) => adapter.addOne(securityInfo, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectSecurityInfoIds = selectIds;

export const selectSecurityInfoEntities = selectEntities;

export const selectSecurityInfo = selectAll;
